import { HomePage } from "@src/pages/Home";
import { redirect } from "react-router-dom";

export function meta() {
  return [
    { title: "Home" },
    { name: "description", content: "Welcome to React Router!" },
  ];
}

export async function clientLoader() {
  return redirect("/login");
}

export default function Home() {
  return <HomePage />;
}
